module.exports = __webpack_public_path__ + "static/media/prev-step-button.00ab0a8b.svg";